<template>
	<div id="page404" class="page-not-found main" >
		<div class="inner">
			
			<h1>{{ _("you lost") }}</h1>
			<router-link to="/">
				<Button aria-label="Back to Home page" uppercase type="light">{{_('back to home')}}</Button>
			</router-link>
		</div>
		<div class="ocean">
			<div class="wave"></div>
			<div class="wave"></div>
		</div>

	</div>
</template>


<script>
import Button from '@/components/elements/Button';

export default {
	name: 'PAGE-NOT-FOUND',
	components: {
		Button
	},
	beforeCreate() {
		window.$('html').addClass('is-404');
	},
	destroyed() {
		window.$('html').removeClass('is-404');
		
	},
}
</script>

<style lang="scss">
@import "./../assets/vars.scss";
@import "./../assets/mixins.scss";
html.is-404{
	 body, #app { min-height: 100vh; }
	 #app{
		min-height: 100vh;
		display: flex;
		flex-direction: column;
	}
	.lost-text{
		position: absolute;
		font-weight: 900;
		top: -50%;
		left: 50%;
		transform: translateX(-50%);
		color: rgba(136, 196, 219, 0.1);
		span{
			@include fluid-type($smallResText, $wideResText, 466px, 820px);
		}
	}
	body {
		background:radial-gradient(ellipse at center, rgba(255,254,234,1) 0%, rgba(255,254,234,1) 35%, #E5F2F4 100%);
		overflow-x: hidden;
		}
		.theme-header{
			background: transparent;
			.holder-top{
				background: transparent;
			}
		}
		.page-not-found{
			flex: 1;
			position: relative;
			min-height: 60vh;
			@include mquery($tablet){
				min-height: 400px;
			}
			.inner{
				z-index: 99;
				text-align: center;
				position: absolute;
				left: 50%;
				top: 100px;
				transform: translateX(-50%);
				@include mquery($tablet){
					top: 0;
				}
				@include mquery($phone){
					top: -50px;
				}
				h1{
					padding-top: 40px;
					font-weight: bold;
					margin-bottom: 20px;
					color: $darkLighten;
					text-shadow: 4px 2px 0px $darkL;
					@include fluid-type($smallResText, $wideResText, 32px, 50px);
				}
			}
		}
		.ocean { 
		height: 5%;
		width:100%;
		position:absolute;
		bottom:0;
		margin-bottom: -25px;
		left:0;
		background: #005782;
		@include mquery($tablet){
			margin-bottom: -5px;
		}
		}
		.wave {
			background: url('./../assets/wave.svg') repeat-x; 
			position: absolute;
			top: -198px;
			width: 6400px;
			height: 198px;
			animation: wave 7s cubic-bezier( 0.36, 0.45, 0.63, 0.53) infinite;
			transform: translate3d(0, 0, 0);
			@include mquery($tablet){
				
			}
			@include mquery($phone){
			}
		}

		.wave:nth-of-type(2) {
			top: -175px;
			animation: wave 7s cubic-bezier( 0.36, 0.45, 0.63, 0.53) -.125s infinite, swell 7s ease -1.25s infinite;
			opacity: 1;
			@include mquery($tablet){
			}	
		}

		@keyframes wave {
		0% {
			margin-left: 0;
		}
		100% {
			margin-left: -1600px;
		}
		}

		@keyframes swell {
		0%, 100% {
			transform: translate3d(0,-25px,0);
		}
		50% {
			transform: translate3d(0,5px,0);
		}
		}
		#theme-footer{
			.curved-block-line{
				display: none;
			}
		}
		#theme-header{
			.curved-top{
				display: none;
			}
		}
}


</style>
